'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _InfoOutlined = require('./lib/icons/InfoOutlined');
  
  
  var _default = _InfoOutlined;
  exports.default = _default;
  module.exports = _default;